import { connect } from 'react-redux';
import View from './DistributionsView';
import { goalId as selectedGoalId } from '../../../FinancialPlanGoalDropdown/FinancialPlanGoalDropdownSelector';
import { DISTRIBUTIONS_WHAT_IF_KEY, DISTRIBUTIONS_WHAT_IF_PATH } from './DistributionsConstants';
import {
  withDisplayedDistributionOrder,
  withEffectiveDistributionOrder,
} from './DistributionsUtils';
import {
  distributionsSelector,
  distributionsIsCustomSelector,
  includedDistributionAccountsSelector,
  excludedDistributionAccountsSelector,
} from './DistributionsSelector';
import {
  updateWhatIfsData,
  applyWhatIf,
  fetchWhatIfOptions,
  planImpact,
  initialPlanImpact,
  removeFetchOptionsApply,
} from '../../WhatIfsActions';
import {
  loading,
  nullableFpIdSelector,
  areOptionsLoaded,
  whatIfInnerSelector,
  whatIfTemplateInnerSelector,
  impactSelector,
  nullableTitleSelector,
  nullableGroupTitleSelector,
  whatIfIsAppliedSelector,
  isOPLMonteCarloSelector,
} from '../../WhatIfsSelector';

const mapStateToProps = (state, ownProps) => ({
  fpId: nullableFpIdSelector(state, ownProps),
  goalId: selectedGoalId(state, ownProps),
  areOptionsLoaded: areOptionsLoaded(state, ownProps),
  whatIf: whatIfInnerSelector(state, ownProps),
  whatIfIsApplied: whatIfIsAppliedSelector(state, ownProps),
  whatIfTemplate: whatIfTemplateInnerSelector(state, ownProps),
  loading: loading(state, ownProps),
  title: nullableTitleSelector(state, ownProps),
  groupTitle: nullableGroupTitleSelector(state, ownProps),
  planImpactItems: impactSelector(state, ownProps),
  distributions: distributionsSelector(state, ownProps),
  distributionsIsCustom: distributionsIsCustomSelector(state, ownProps),
  includedDistributionAccounts: includedDistributionAccountsSelector(state, ownProps),
  excludedDistributionAccounts: excludedDistributionAccountsSelector(state, ownProps),
  isOPLMonteCarlo: isOPLMonteCarloSelector(state),
});

const mapDispatchToProps = dispatch => ({
  storeData: goalId => (data, clientId) => {
    dispatch(updateWhatIfsData(clientId, goalId, DISTRIBUTIONS_WHAT_IF_KEY, data));
  },
  fetchPlanImpact: (
    clientId,
    fpId,
    goalId,
    whatIf,
    whatIfTemplate,
    includedDistributionAccounts,
  ) => {
    dispatch(
      planImpact(
        clientId,
        fpId,
        goalId,
        withEffectiveDistributionOrder(whatIf, includedDistributionAccounts),
        DISTRIBUTIONS_WHAT_IF_PATH,
        Object.keys(whatIfTemplate),
        DISTRIBUTIONS_WHAT_IF_KEY,
      ),
    );
  },
  onExcludeAccount: (included, clientId, goalId, accountId) => () => {
    dispatch(
      updateWhatIfsData(clientId, goalId, DISTRIBUTIONS_WHAT_IF_KEY, {
        WhatIf: {
          IncludedDistributionAccounts: included
            .filter(distribution => distribution.AccountId !== accountId)
            .map(({ AccountId }) => AccountId),
          DistributionsIsCustom: true,
        },
      }),
    );
  },
  onIncludeAccount: (included, excluded, clientId, goalId, accountId) => () => {
    dispatch(
      updateWhatIfsData(clientId, goalId, DISTRIBUTIONS_WHAT_IF_KEY, {
        WhatIf: {
          IncludedDistributionAccounts: included
            .concat(excluded.filter(distribution => distribution.AccountId === accountId))
            .map(({ AccountId }) => AccountId),
          DistributionsIsCustom: true,
        },
      }),
    );
  },
  fetchInitialPlanImpact: (
    clientId,
    fpId,
    goalId,
    whatIf,
    whatIfTemplate,
    includedDistributionAccounts,
  ) => {
    dispatch(
      initialPlanImpact(
        clientId,
        fpId,
        goalId,
        withEffectiveDistributionOrder(whatIf, includedDistributionAccounts),
        DISTRIBUTIONS_WHAT_IF_PATH,
        Object.keys(whatIfTemplate),
        DISTRIBUTIONS_WHAT_IF_KEY,
      ),
    );
  },
  fetchData: (clientId, fpId, goalId, callBack) => {
    dispatch(
      fetchWhatIfOptions(
        clientId,
        fpId,
        goalId,
        DISTRIBUTIONS_WHAT_IF_PATH,
        DISTRIBUTIONS_WHAT_IF_KEY,
        callBack,
      ),
    );
  },
  applyWhatIf: (
    clientId,
    fpId,
    goalId,
    whatIf,
    whatIfTemplate,
    includedDistributionAccounts,
  ) => () => {
    dispatch(
      applyWhatIf(
        clientId,
        fpId,
        goalId,
        withEffectiveDistributionOrder(whatIf, includedDistributionAccounts),
        DISTRIBUTIONS_WHAT_IF_PATH,
        Object.keys(whatIfTemplate),
        DISTRIBUTIONS_WHAT_IF_KEY,
      ),
    );
  },
  onDrop: (clientId, fpId, goalId, whatIf, whatIfTemplate, includedDistributionAccounts) => () => {
    dispatch(
      planImpact(
        clientId,
        fpId,
        goalId,
        withDisplayedDistributionOrder(whatIf, includedDistributionAccounts),
        DISTRIBUTIONS_WHAT_IF_PATH,
        Object.keys(whatIfTemplate),
        whatIfTemplate.WhatIfType,
      ),
    );
  },
  addAccountItem: () => {},
  removeAccountItem: () => {},
  resetToDefault: (clientId, fpId, goalId, whatIfIsApplied, whatIf, whatIfTemplate) => () => {
    if (!whatIfIsApplied) {
      dispatch(
        updateWhatIfsData(clientId, goalId, DISTRIBUTIONS_WHAT_IF_KEY, {
          WhatIf: {
            IncludedDistributionAccounts: null,
            DistributionsIsCustom: false,
          },
        }),
      );
    } else {
      dispatch(
        removeFetchOptionsApply(
          clientId,
          fpId,
          goalId,
          DISTRIBUTIONS_WHAT_IF_PATH,
          whatIf,
          Object.keys(whatIfTemplate),
          () => {
            dispatch(
              updateWhatIfsData(clientId, goalId, DISTRIBUTIONS_WHAT_IF_KEY, {
                WhatIf: {
                  IncludedDistributionAccounts: null,
                  DistributionsIsCustom: false,
                },
              }),
            );
          },
        ),
      );
    }
  },
  moveAccountItem: (included, clientId, goalId) => (dragIndex, hoverIndex) => {
    const onlyAccountIds = included.map(({ AccountId }) => AccountId);
    const movedAccount = onlyAccountIds[dragIndex];
    onlyAccountIds.splice(dragIndex, 1);
    onlyAccountIds.splice(hoverIndex, 0, movedAccount);
    dispatch(
      updateWhatIfsData(clientId, goalId, DISTRIBUTIONS_WHAT_IF_KEY, {
        WhatIf: {
          IncludedDistributionAccounts: onlyAccountIds,
          DistributionsIsCustom: true,
        },
      }),
    );
  },
  moveAccountAndFetch: (
    included,
    clientId,
    fpId,
    goalId,
    whatIf,
    whatIfTemplate,
    index,
    offset,
  ) => () => {
    const newIndex = index + offset;
    if (newIndex < 0 || newIndex >= included.length) {
      return;
    }
    const onlyAccountIds = included.map(({ AccountId }) => AccountId);
    const movedAccount = onlyAccountIds[index];
    onlyAccountIds.splice(index, 1);
    onlyAccountIds.splice(newIndex, 0, movedAccount);
    const newWhatIf = {
      ...whatIf,
      IncludedDistributionAccounts: onlyAccountIds,
      DistributionsIsCustom: true,
    };
    dispatch(
      updateWhatIfsData(clientId, goalId, DISTRIBUTIONS_WHAT_IF_KEY, {
        WhatIf: newWhatIf,
      }),
    );
    dispatch(
      planImpact(
        clientId,
        fpId,
        goalId,
        newWhatIf,
        DISTRIBUTIONS_WHAT_IF_PATH,
        Object.keys(whatIfTemplate),
        whatIfTemplate.WhatIfType,
      ),
    );
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(View);
